function increase (el, binding) {
  const { value } = binding
  if (value < 0) {
    el.style.color = 'green'
    el.innerHTML = '<i class="el-icon-bottom"></i> ' + formatAmount(value)
  } else if (value > 0) {
    el.style.color = 'red'
    el.innerHTML = '<i class="el-icon-top"></i> ' + formatAmount(value)
  } else {
    el.innerHTML = value.toLocaleString()
  }
}

function formatAmount (number) {
  const str = number.toString()
  const parts = str.split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
}

export default {
  // 在绑定元素的父组件被挂载之后调用
  mounted (el, binding) {
    increase(el, binding)
  },

  // 在包含组件的 VNode 以及 子组件 的 VNode 更新后调用
  updated (el, binding) {
    increase(el, binding)
  }
}
